module.exports = __webpack_public_path__ + "static/img/13areaB_3.191f6af.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_3.png
// module id = 1110
// module chunks = 1